<template>
  <b-modal size="lg" :visible="visible" no-close-on-backdrop no-close-on-esc centered>
    <div slot="modal-header" class="w-100">
      <h5>Estimate Discount
        <button type="button" class="close"
                @click.prevent="closeModal()">
          <span aria-hidden="true">&times;</span></button>
      </h5>
    </div>
    <b-form>
      <div class="container-fluid">
        <div class="row justify-content-center">
          <div class="col-10">
            <b-form-group :label-cols="5" label="Percentage of Discount" label-align="right">
              <b-input-group append="%">
                <b-form-input v-model="discount.percentage"/>
              </b-input-group>
            </b-form-group>
          </div>
        </div>
        <div class="row justify-content-center">
          <div class="col-10">
              <b-form-group :label-cols="5" id="expirationDateFieldGroup"
                            invalid-feedback="Expiration Date is not valid"
                            label="Discount Expiration Date"
                            label-align="right">
                <datepicker placeholder="mm/dd/yyyy" format="MM/dd/yyyy" :use-utc="true"
                            :typeable="true" class="form-control datepicker"
                            v-model="discount.expiration"></datepicker>
              </b-form-group>
          </div>
        </div>

      </div>
    </b-form>
    <div slot="modal-footer" class="w-100">
      <button type="button" class="btn btn-orange float-right" @click.prevent="save()">
        Save
      </button>
      <button type="button" class="btn btn-outline-orange mr-2 float-right" @click.prevent="closeModal()">Close</button>
    </div>
  </b-modal>
</template>

<script>

  import Datepicker from 'vuejs-datepicker'
  import moment from 'moment'
  import AnalyticsMixin from '@/mixins/AnalyticsMixin'

  export default {
    name: 'EditEstimateDiscountModal',

    components: { Datepicker },

    mixins: [AnalyticsMixin],

    props: {
      visible: {
        type: Boolean,
        required: true
      },
      discountPercent: {
        type: Number,
        required: false
      },
      discountExpiration: {
        type: String,
        required: false
      }
    },

    data () {
      return {
        percentageString: '',
        discount: {
          percentage: '10',
          expiration: moment()
        },
        date: null
      }
    },

    watch: {
      discountPercent (newValue, oldValue) {
        this.discount.percentage = this.formatPercentageString(newValue)
      },

      discountExpiration (newValue, oldValue) {
        if (newValue !== oldValue) {
          this.discount.expiration = newValue
        }
      }
    },

    methods: {
      formatPercentageString (number) {
        if (number) {
          return (number * 100).toFixed(0)
        }

        return ''
      },

      formatPercentageNumber (string) {
        if (string) {
          return (parseFloat(string) / 100.0)
        }

        return 0.0
      },

      save () {
        this.$emit('estimateDiscountUpdated', this.formatPercentageNumber(this.discount.percentage), moment(this.discount.expiration).toISOString())
      },

      closeModal () {
        this.trackEvent('Estimate', 'EditDiscountModal', 'Closed')
        this.$emit('update:visible', false)
      }
    }
  }
</script>

<style scoped>

</style>
